module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Game lobby: " + _vm._s(_vm.game.name))]), _c('player-list', {
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(ref) {
        var player = ref.player;

        return [(player.isReady) ? _c('v-icon', {
          staticClass: "green--text",
          attrs: {
            "medium": ""
          }
        }, [_vm._v("check")]) : _c('v-icon', {
          attrs: {
            "medium": ""
          }
        }, [_vm._v("hourglass_empty")])]
      }
    }])
  }), _c('v-layout', {
    staticClass: "box-container"
  }, [_c('v-flex', {
    staticClass: "box"
  })], 1), _c('v-layout', {
    attrs: {
      "slot": "footer",
      "align-center": "",
      "justify-center": ""
    },
    slot: "footer"
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")]), (_vm.localPlayer.isReady) ? _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.ready(false)
      }
    }
  }, [_vm._v("Not ready")]) : _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.ready(true)
      }
    }
  }, [_vm._v("Ready")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b069ba1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/game-states/LOBBY/index.vue
// module id = 337
// module chunks = 0